import { createContext } from 'react';

import { BackupSummary } from '@totem/components/services/backup/deviceBackups/backupSummary/types';

interface Context {
  loading: boolean;
  data: BackupSummary;
  action: string;
  onAction?: (action: string) => void;
}

export default createContext<Context>({
  loading: false,
  data: null,
  action: '',
  onAction: () => {},
});
